module.exports = __webpack_public_path__ + "img/home.8ec21d1d.png";